/**
 * Utility function to clear temporary account status from storage
 * This can be used to manually clear the temporary account warning
 * for users who have already claimed their account but still see the warning
 */
export const clearTemporaryStatus = (): void => {
  console.log("Manually clearing temporary account status");

  // Clear session storage items
  sessionStorage.removeItem("fitbuzz_temporary_account");
  sessionStorage.removeItem("fitbuzz_temp_email");
  sessionStorage.removeItem("fitbuzz_temp_user_id");
  sessionStorage.removeItem("fitbuzz_temp_user_name");
  sessionStorage.removeItem("fitbuzz_temp_user_role");
  sessionStorage.removeItem("fitbuzz_temp_origin_app_id");
  sessionStorage.removeItem("fitbuzz_temp_user_data");
  sessionStorage.removeItem("fitbuzz_temp_auth_properties");
  sessionStorage.removeItem("fitbuzz_temp_course_access");

  // Update localStorage user if it exists
  const storedUserJson = localStorage.getItem("fitbuzz_user");
  if (storedUserJson) {
    try {
      const storedUser = JSON.parse(storedUserJson);

      // Set is_temporary to false
      if (storedUser.is_temporary !== false) {
        storedUser.is_temporary = false;
        localStorage.setItem("fitbuzz_user", JSON.stringify(storedUser));
        console.log("Updated user in localStorage to non-temporary status");
      }
    } catch (err) {
      console.error("Error updating user in localStorage:", err);
    }
  }

  console.log("Temporary account status cleared");
};

/**
 * Utility function to check if a user has a temporary account
 * This can be used to determine if the temporary account warning should be shown
 */
export const hasTemporaryAccount = (): boolean => {
  // Check localStorage first (most up-to-date source)
  const storedUserJson = localStorage.getItem("fitbuzz_user");
  if (storedUserJson) {
    try {
      const storedUser = JSON.parse(storedUserJson);
      if (storedUser.is_temporary === false) {
        return false;
      }
      if (storedUser.is_temporary === true) {
        return true;
      }
    } catch (err) {
      console.error("Error checking temporary status from localStorage:", err);
    }
  }

  // Check session storage
  const sessionTemporary =
    sessionStorage.getItem("fitbuzz_temporary_account") === "true";
  if (sessionTemporary) {
    return true;
  }

  // Check user data in session storage
  const userDataJson = sessionStorage.getItem("fitbuzz_temp_user_data");
  if (userDataJson) {
    try {
      const userData = JSON.parse(userDataJson);
      if (userData.is_temporary === true) {
        return true;
      }
    } catch (err) {
      console.error(
        "Error checking temporary status from session storage:",
        err
      );
    }
  }

  return false;
};
